import { required } from 'components/form/form.util';
import type { CampaignConfigProviderCampaignFragment } from 'generated/graphql';
import type { OverviewSectionConfig } from '../../campaign-configs/types';

/**
 * Builds the overview section configuration from the database campaign configuration.
 * Uses the overviewConfiguration from the database to determine supported inputs and their validation requirements.
 * Falls back to hardcoded configuration for backward compatibility during migration.
 */
export const buildOverviewConfig = (config: CampaignConfigProviderCampaignFragment): OverviewSectionConfig => {
  const defaultSupportedInputs = {
    additionalText: {
      validateFieldFn: undefined,
    },
    eventShortName: {
      validateFieldFn: undefined,
    },
    program: {
      validateFieldFn: required,
    },
  };

  // Transform database overviewConfiguration to frontend format if available
  const databaseConfigInputs = config.overviewConfiguration?.autoNaming.supportedInputs
    ? Object.entries(
        config.overviewConfiguration.autoNaming.supportedInputs as Record<
          string,
          {
            required: boolean;
          }
        >,
      ).reduce(
        (inputs, [key, value]) => {
          inputs[key] = {
            validateFieldFn: value.required ? required : undefined,
          };
          return inputs;
        },
        {} as Record<
          string,
          {
            validateFieldFn: typeof required | undefined;
          }
        >,
      )
    : {};

  // Give preference to db config values
  const supportedInputs = {
    ...defaultSupportedInputs,
    ...databaseConfigInputs,
  };

  return {
    autoNaming: {
      staticAutoNamingValues: {
        widgetName: config.shortName,
      },
      supportedInputs,
    },
  };
};
